import { Component } from "react"
import API, { URL_PATH } from "../../services/API"
import redux from "../../common/Redux"
import routes from "../../routes/URL"
import { Button, TextField, CardContent, CardHeader, Box, Typography, Container } from "@mui/material"
import IsolatedStatusModal from "../../components/StatusModal"
import Toast from "../../components/Toast"
import Header from "../../components/Header"

class ListHotelScreen extends Component {
  constructor(props) {
    super(props)
    this.state = {
      toast: {
        open: false,
        message: "",
        severity: "success" 
      }      
    }
  }

  componentDidMount() { 
    const hotel = this.props.hotels.find(h => h.hotel_slug === this.props.match.params.hotelSlug);
    if (!hotel) {
        this.props.history.push(routes.admin.dashboard.root(this.props.hotels[0]?.hotel_slug || ''));
        return;
    }
  }

  create = async () => {
    const formdata = new FormData(document.getElementById("hotelForm"))
    formdata.append("hotel_id", this.props.selectedHotelId.id)
    formdata.append("tax_rate", this.state.taxRate || 0) // Add tax rate to form data
    console.log([...formdata.entries()]) // Better logging of FormData
    
    const { status, message, data } = await API(this, "post", URL_PATH.createFloor, formdata)

    if (status == "success") {
      this.setState({
        toast: {
          open: true,
          message: message,
          severity: "success"
        }
      });
      setTimeout(() => {
        this.props.history.push(routes.admin.floors.list(this.props.hotels[0]?.hotel_slug || ''));
      }, 2000); // Redirect after 2 seconds
    } else {
      this.setState({
        toast: {
          open: true,
          message: message,
          severity: "error"
        }
      });
    }
  };

  handleTaxRateChange = (e) => {
    this.setState({ taxRate: e.target.value })
  }

  handleSuccessModalClose = () => {
    this.setState({ showSuccessModal: false })
    this.props.history.push(routes.admin.floors.list(this.props.hotels[0]?.hotel_slug || ''))
  }

  handleErrorModalClose = () => {
    this.setState({ showErrorModal: false })
  }

  render() {
    return (
      <Container maxWidth="lg" className="py-5">
        <Box
          sx={{ 
            borderRadius: "10px",
            overflow: "hidden",
            bgcolor: "transparent",
            border: "1px solid #FFC857",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          }}
        > 
          
           <CardHeader
                      title={
                        <Header title="Create Space" />
          
                      }
                      sx={{ pb: 2 }}
                    />
          <CardContent sx={{}}>
            <form
              id="hotelForm"
              name="hotelForm"
              onSubmit={(e) => {
                e.preventDefault()
                return this.create()
              }}
            >
              <Box mb={3}>
                <TextField
                  fullWidth
                  id="floor_no"
                  name="floor_no"
                  label="Space Name"
                  placeholder="Enter Space Name"
                  variant="outlined"
                  required
                  InputProps={{
                    sx: {
                      borderRadius: 1,
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'white !important',
                      },
                    },
                  }}
                  InputLabelProps={{
                    sx: {
                      '&.Mui-focused': {
                        color: 'white !important',
                      },
                    },
                  }}
                />
              </Box>

              <Box mb={3}>
                <TextField
                  fullWidth
                  id="tax_rate"
                  name="tax_rate"
                  label="Tax Rate (%)"
                  placeholder="Enter Tax Rate"
                  variant="outlined"
                  type="number"
                  value={this.state.taxRate}
                  onChange={this.handleTaxRateChange}
                  InputProps={{
                    sx: {
                      borderRadius: 1,
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'white !important',
                      },
                      input: {
                        inputMode: 'numeric',
                        pattern: '[0-9]*'
                      }
                    },
                  }}
                  InputLabelProps={{
                    sx: {
                      '&.Mui-focused': {
                        color: 'white !important',
                      },
                    },
                  }}
                />
              </Box>

              <Box mt={4} display="flex" justifyContent="flex-start">
                <Button
                  variant="contained"
                  type="submit"
                  size="large"
                  sx={{
                    px: 4,
                    py: 1,
                    borderRadius: 1,
                    textTransform: "none",
                    fontWeight: 700,
                    bgcolor: "#FFC857",
                    "&:hover": {
                      bgcolor: "#E6B54E",
                    },
                  }}
                >
                  Submit
                </Button>
              </Box>
            </form>
          </CardContent>
        </Box>

        <Toast
        open={this.state.toast.open}
        message={this.state.toast.message}
        severity={this.state.toast.severity}
        handleClose={() => this.setState({ toast: { ...this.state.toast, open: false } })}
      />
        
      </Container>
    )
  }
}

export default redux(ListHotelScreen)